export default "__VITE_ASSET__CI748DCl__"